import React from 'react';
import PropTypes from 'prop-types';

const ProgressCircle = (props) => {
  const { progress: progressProps } = props;
  let icon;
  let circle;

  const progress = parseInt(progressProps, 10);

  if (progress > 0) {
    circle = (
      <path
        className="circle"
        strokeDasharray={`${progressProps},100`}
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
      />
    );
  }
  if (progress === 100) {
    icon = (
      <path
        className="icon"
        d="m 15.452716,23.428235 -4.406228,-4.406227 c -0.264718,-0.26472 -0.264718,-0.693929 0,-0.958674 l 0.958646,-0.958674 c 0.264718,-0.264744 0.693955,-0.264744 0.958673,0 l 2.968246,2.968222 6.357652,-6.357629 c 0.264718,-0.264715 0.693955,-0.264715 0.958673,0 l 0.958645,0.958674 c 0.264718,0.264719 0.264718,0.693929 0,0.958674 l -7.795634,7.795659 c -0.264745,0.264719 -0.693955,0.264719 -0.958673,-2.5e-5 z"
      />
    );
  } else {
    icon = (
      <path
        className="icon"
        d="m 18.66019,15.067348 v -2.951565 h -4.340574 c -0.288553,0 -0.520788,0.232238 -0.520788,0.520972 v 10.069976 c 0,0.288733 0.232235,0.520972 0.520788,0.520972 h 7.292134 c 0.288735,0 0.520787,-0.232239 0.520787,-0.520972 V 15.58832 h -2.95156 c -0.286534,0 -0.520787,-0.234628 -0.520787,-0.520972 z m 1.388828,5.122026 c 0,0.143085 -0.117218,0.260307 -0.260302,0.260307 h -3.646067 c -0.143267,0 -0.260486,-0.117222 -0.260486,-0.260307 v -0.173536 c 0,-0.143267 0.117219,-0.260481 0.260486,-0.260481 h 3.646067 c 0.143268,0 0.260302,0.117214 0.260302,0.260481 z m 0,-1.389198 c 0,0.143085 -0.117218,0.260308 -0.260302,0.260308 h -3.646067 c -0.143267,0 -0.260486,-0.117223 -0.260486,-0.260308 V 18.62664 c 0,-0.143267 0.117219,-0.260481 0.260486,-0.260481 h 3.646067 c 0.143268,0 0.260302,0.117214 0.260302,0.260481 z m 0,-1.562542 v 0.173536 c 0,0.143267 -0.117218,0.260481 -0.260302,0.260481 h -3.646067 c -0.143267,0 -0.260486,-0.117214 -0.260486,-0.260481 v -0.173536 c 0,-0.143085 0.117219,-0.260307 0.260486,-0.260307 h 3.646067 c 0.143084,-1.83e-4 0.260302,0.117222 0.260302,0.260307 z m 2.083519,-2.476266 v 0.132445 h -2.778024 v -2.77803 h 0.132443 c 0.138865,0 0.271309,0.05428 0.368899,0.15189 l 2.124793,2.126813 c 0.0976,0.09777 0.151889,0.230213 0.151889,0.366882 z"
      />
    );
  }

  return (
    <div className="circular-chart-wrapper">
      <svg viewBox="0 0 36 36" className="circular-chart">
        <path
          className={progress === 100 ? 'circle-bg circle-bg-full' : 'circle-bg'}
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        {circle}
        {icon}
      </svg>
    </div>
  );
};

export default ProgressCircle;

ProgressCircle.propTypes = {
  progress: PropTypes.number,
};

ProgressCircle.defaultProps = {
  progress: undefined,
};
